// Default Breakpoints:
// xs, extra-small: 0px
// sm, small: 600px
// md, medium: 900px
// lg, large: 1200px
// xl, extra-large: 1536px

const breakpoints = {
  mobile: "600px",
  tablet: "900px",
  laptop: "1200px",
  desktop: "1536px",
};

export const deviceSpec = {
  isMobile: `(max-width: ${breakpoints.mobile})`,
  isTablet: `(max-width: ${breakpoints.tablet})`,
  isLaptop: `(max-width: ${breakpoints.laptop})`,
  isDesktop: `(max-width: ${breakpoints.desktop})`,
};
